module.exports = __webpack_public_path__ + "media/images/flags/1x1/caf-14cbe1af42d053392bf761ef08281644.svg";